import { Titled } from 'react-titled';
import type { FC } from 'react';
import PinterestFormProvider from 'features/pinterest/components/PinterestFormProvider';

const PinterestPage: FC = () => (
  <>
    <Titled title={(title) => `WellTech User Acquisition | ${title}`} />
    <PinterestFormProvider />
  </>
);

export default PinterestPage;
